import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetDocumentType = (documentTypeName) => {
  let url = `/DocumentType/GetDocumentTypeList`;
  if (documentTypeName) {
    url += `?documentTypeName=${documentTypeName}`
  }
  const data = useQuery(["documentTypeList", documentTypeName], () =>
    axiosClient.get(url)
  );

  return data;
};
export default useGetDocumentType;
